module.exports = __webpack_public_path__ + "media/games-21.2bc3a066.mp4";